
export default function styles(theme) {
  return {
    section: {
      marginBottom: 80,
    },
    title: {
      display: "block",
      width: "100%",
      textAlign: "center",
      ...theme.palette.text.gradient
    },
    subtitle: {
      display: "block",
      width: "100%",
      color:theme.palette.text.primary,
      transition: "0.5s",
    },
    description: {
      margin: "auto",
      display: "block",
      width: "100%",
      textAlign: "center",
      fontSize: "1rem",
      color: theme.palette.text.tertiary
    },
    secondaryDesc: {
      color: theme.palette.text.tertiary,
      width: "100%",
    },
    textAlignLeft: {
      display: 'flex',
      gap: '20px',
      margin: 0,
      marginBottom: 20,
      textAlign: "left",
       [theme.breakpoints.down("xs")]: {
         textAlign: "left",
      },
    },
    links:{
      color: theme.palette.text.primary,
      fontWeight:"300",
      textDecoration: "none",
      padding: "8px 0px",
      display: "inline-block",
      position: "relative",
      borderBottom: "0.5px solid #434f66",
      strokeLinecap:"round",
      lineHeight: "20px",
      display: 'flex',
      alignItems:'center',
      justifyContent:'center',
      transformOrigin: "left bottom",
      gap:'10px',
      "&::after":{
        content: '""',
        position: "absolute",
        width: "100%",
        transform: "scaleX(0)",
        height: "0.5px",
        bottom: "-1px",
        left: "0px",
        borderRadius: "20px",
        zIndex: "2",
        backgroundColor: theme.palette.text.primary,
        transformOrigin: "bottom right",
        transition: "transform 0.4s cubic-bezier(0.86, 0, 0.07, 1)",
      },
      "&:hover::after":{
        transform: "scaleX(1)",
        transformOrigin: "bottom left",
      }
    },
    content:{
      width:'100%',
    },
    heroBtns: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      gap: 40,
      marginTop: 54,
      [theme.breakpoints.down("sm")]: {
         gap: 18,
      },
    },
    categoriesIllustration: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: 8,
      background: "rgb(142,162,199,0.15)",
    },
    categoriesSection:{
      zIndex: "0",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
    },
    imageContainer: {
      display: "flex",
      justifyContent: "flex-end",
      border: "1px solid rgba(121, 131, 150, 0.2)",
      position: "relative",
      zIndex: "0",
      borderRadius: 12,
      height:"22rem",
      [theme.breakpoints.down("sm")]: {
        marginBottom:'2rem',
        height:"15rem",
      }
    },
    video: {
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        height: 300,
        // display: "flex",
      },
    },
    videoDesc: {
      marginTop: 40,
    },
  };
}
